module.exports = __webpack_public_path__ + "img/delete.5847c2df.svg";